import { render, staticRenderFns } from "./SupervisorWorkerTable.vue?vue&type=template&id=deec12ca&scoped=true"
import script from "./SupervisorWorkerTable.vue?vue&type=script&lang=js"
export * from "./SupervisorWorkerTable.vue?vue&type=script&lang=js"
import style0 from "./SupervisorWorkerTable.vue?vue&type=style&index=0&id=deec12ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deec12ca",
  null
  
)

export default component.exports